<template>
  <header class="header-wrapper">
    <div class="nav-wrapper">
    <nav class="navbar navbar-expand-md navbar-light">
      <div class="container align-items-sm-center">
        <div class="section image-block-container nav-brand" data-section-status="loaded">
          <div class="image-block-wrapper">
            <div class="image-block block" data-block-name="image-block" data-block-status="loaded">
              <div>
                <div>
                  <router-link to="/Home">
                    <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-Nav"
          @click="toggleCollapse" aria-controls="navbar-Nav" aria-expanded="false" aria-label="Toggle navigation"
          :class="{ active: isCollapsed }" v-if="!$route.meta.hideNav"></button>

        <div :class="{ show: isCollapsed }" class="collapse navbar-collapse justify-content-end my-2" id="navbar-Nav"
          v-if="!$route.meta.hideNav">
          <div class="offcanvas-header d-md-none">
            <router-link to="/Home">
              <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
            </router-link>
          </div>

          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link text-uppercase" @click="closeMenu">
                {{ $t('Header.UploadTab') }}
              </router-link>
            </li>
            <li class="nav-item ms-md-3">
              <router-link to="/Support" class="nav-link text-uppercase" @click="closeMenu">
                {{ $t('Header.SupportTab') }}
              </router-link>
            </li>
             <li class="nav-item ms-md-3">
              <a href="https://www.frostedflakes.us/mission-tiger/" class="nav-link text-uppercase" target="_blank">Mission Tiger Home</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div>
  </header>

  <banner></banner>
</template>


<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
      handleBodyScroll();
    };

    const closeMenu = () => {
      isCollapsed.value = false;
      handleBodyScroll();
    };

    const handleBodyScroll = () => {
      if (isCollapsed.value) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      const hostname = window.location.hostname;
      const isLocal = hostname === "localhost";
      const isStaging = hostname.includes("staging");

      if (isLocal) {
        // Local: Change language dynamically
        await loadLocaleMessages(lang);
        locale.value = lang;
        localStorage.setItem("locale", lang);
        currentLang.value = lang;
        injectGTM();
      } else {
        // Staging & Production: Redirect to language-specific domains
        const currentPath = window.location.pathname;
        const currentQuery = window.location.search;

        const langBaseUrls = {
          en: isStaging ? "https://staging-summerofsoccercontest.snipp.us" : "http://www.summerofsoccercontest.ca",
          fr: isStaging ? "https://staging-concoursdefootballestival.snipp.us" : "http://www.concoursdefootballestival.ca",
        };

        const targetBase = langBaseUrls[lang] || "/";
        const targetUrl = `${targetBase}${currentPath}${currentQuery}`;

        window.location.href = targetUrl;
      }
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      injectGTM();
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll("[data-gtm]").forEach(el => el.remove());

      const script = document.createElement("script");
      script.setAttribute("data-gtm", gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    return { currentLang, changeLanguage, isCollapsed, toggleCollapse, closeMenu };
  },
};
</script>
